import { Form, Formik } from 'formik';
import React, { FC, useState } from 'react';
import * as yup from 'yup';
import { FavouriteBasketType } from '../../../models/favourite-basket-type';
import { FavouriteBasketsType } from '../../../models/favourite-baskets-type';
import FormErrorTypeEnum from '../../../models/form-error-type-enum';
import categoryStructure from '../../../services/content-api/endpoints/category/structure';
import favouritesCreate from '../../../services/customer-api/endpoints/favourites/create';
import ButtonSecondary from '../../atoms/button-secondary/button-secondary';
import FormText from '../../atoms/form-text/form-text';

interface Props extends FavouriteBasketsType {
  readonly onSuccess: (allBaskets: FavouriteBasketType[]) => void;
}

const FavouriteBasketsAddForm: FC<Props> = ({
  addNewBasketButtonText,
  addNewBasketFieldLabel,
  addNewBasketPlaceholderLabel,
  onSuccess,
}: Props) => {
  const [formSuccessfullySubmitted, setFormSuccessfullySubmitted] =
    useState<boolean>(null);

  return (
    <Formik
      initialValues={{
        name: '',
      }}
      validationSchema={yup.object({
        name: yup.string().required().trim().label(addNewBasketFieldLabel),
      })}
      onSubmit={async (values, { setErrors, setTouched, setValues }) => {
        try {
          const { catalogId } = await categoryStructure();
          const allBaskets = await favouritesCreate(catalogId, values.name);

          onSuccess(allBaskets);
          setValues({ name: '' });
          setTouched({ name: false });
          setFormSuccessfullySubmitted(true);
        } catch (error) {
          if (error?.response?.data?.message) {
            setErrors({
              name: error.response.data.message,
            });

            return;
          }

          setFormSuccessfullySubmitted(false);
        }
      }}
    >
      <Form className="flex flex-col space-y-5">
        <FormText
          label={addNewBasketFieldLabel}
          name="name"
          placeholder={addNewBasketPlaceholderLabel}
        />

        {formSuccessfullySubmitted === false && (
          <span className="block mt-1 text-sm text-invalid">
            {FormErrorTypeEnum.Unknown}
          </span>
        )}

        <div className="flex justify-center">
          <ButtonSecondary buttonType="submit" name={addNewBasketButtonText} />
        </div>
      </Form>
    </Formik>
  );
};

export default FavouriteBasketsAddForm;
